import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['field']

  swallowClick = (event) => {
    event.stopPropagation()
  }

  submit = (event) => {
    if (!this._isDescendant(this.element, event.target)) {
      if (!this._isDescendant(document.querySelector('.select2-container'), event.target)) {
        this.fieldTarget.form.requestSubmit()
      }
    }
  }

  change() {
    this.fieldTarget.form.requestSubmit()
  }

  _isDescendant(parent, child) {
    let node = child.parentNode
    while (node != null) {
      if (node == parent) {
        return true
      }
      node = node.parentNode
    }
    return false
  }
}

